export enum Orientation {
    PERSON = 'Person',
    PLACE = 'Place',
    TIME = 'Time',
    SITUATION = 'Situation',
}